import { render, staticRenderFns } from "./ProductoList.vue?vue&type=template&id=54f4bac5&scoped=true&"
import script from "./ProductoList.vue?vue&type=script&lang=js&"
export * from "./ProductoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4bac5",
  null
  
)

export default component.exports